// Mock data for Qubit Center Battery Course Website

export const mockData = {
  // Site Information
  siteInfo: {
    name: "Qubit Center",
    tagline: "Master Battery Pack Building",
    description: "Learn practical battery pack construction with cost-effective 18650 cell recycling techniques"
  },
  
  // Hero Section
  hero: {
    announcement: "🔋 PRACTICAL COURSE",
    title: "Build Professional Battery Packs with Recycled 18650 Cells",
    subtitle: "Master solid principles while saving costs through our unique recycling approach. Learn hands-on battery pack construction from electronics basics to advanced BMS integration.",
    primaryCTA: "Enroll Now",
    secondaryCTA: "View Curriculum"
  },
  
  // Course Modules
  courseModules: [
    {
      id: "A",
      title: "Electronic Basics",
      color: "accent-orange",
      lessons: [
        "Introduction to Electronics",
        "Ohm's Law Fundamentals", 
        "AC vs DC Current Types",
        "Series & Parallel Connections",
        "Voltage Dividers",
        "Battery Capacity & Ah Ratings",
        "Multi-meter Usage",
        "Battery Connections",
        "DMM Operations",
        "AWG Wire Standards",
        "Fuses & Efficiency Data"
      ]
    },
    {
      id: "B", 
      title: "Lithium Battery Basics",
      color: "accent-blue",
      lessons: [
        "Introduction to Li-ion",
        "Capacity Cycles & DOD/SOC",
        "Voltage/Capacity in Charge/Discharge",
        "C-Rate Calculations",
        "Temperature Effects",
        "Charging Guidelines", 
        "Electrolyte Load Balancing",
        "Energy Density",
        "Storage & Self Discharge",
        "Cell Differences & Capacity",
        "Li-ion vs LiPo Comparison",
        "Li-ion vs LiFePO4",
        "Chemistry Types (LCO,LMO,NMC,NCA,LTO)"
      ]
    },
    {
      id: "C",
      title: "The 18650 Battery", 
      color: "accent-green",
      lessons: [
        "18650 Battery Overview & Why",
        "Reading 18650 Datasheets"
      ]
    },
    {
      id: "D",
      title: "18650 Cell Recycling",
      color: "accent-pink", 
      lessons: [
        "What is Recycling & Benefits",
        "Complete Recycling Process"
      ]
    },
    {
      id: "E",
      title: "Build Your Battery Pack",
      color: "accent-purple",
      lessons: [
        "Battery Calculations (MATH)",
        "How to Build a Battery Pack",
        "Spot Welding Machine DIY",
        "Building 2S1P Packs",
        "Building 3S2P Packs", 
        "Building 4S4P Packs",
        "Balance Wire Setup",
        "Top vs Bottom Balancing"
      ]
    },
    {
      id: "F",
      title: "BMS (Battery Management System)",
      color: "accent-grey",
      lessons: [
        "BMS Fundamentals & Protection",
        "BMS Selection & Installation"
      ]
    },
    {
      id: "G",
      title: "EV Battery Analysis",
      color: "accent-blue",
      lessons: [
        "Tesla Battery Pack Analysis",
        "Volkswagen ID.4 Battery Study"
      ]
    }
  ],
  
  // Key Features
  features: [
    {
      title: "Practical Learning",
      description: "Hands-on experience building real battery packs from start to finish",
      icon: "wrench"
    },
    {
      title: "Cost-Effective Recycling", 
      description: "Learn to recycle 18650 cells, reducing costs by up to 70%",
      icon: "recycle"
    },
    {
      title: "Solid Principles",
      description: "Master fundamental electronic and battery principles that last",
      icon: "book"
    },
    {
      title: "Professional Skills",
      description: "Build industry-standard battery packs with proper BMS integration", 
      icon: "settings"
    }
  ],
  
  // Testimonials
  testimonials: [
    {
      name: "Ahmed Hassan",
      role: "Electronics Engineer",
      text: "The recycling techniques saved me thousands on my EV conversion project. Excellent practical course!",
      avatar: "AH"
    },
    {
      name: "Sarah Chen", 
      role: "Renewable Energy Tech",
      text: "Finally learned proper battery pack construction. The hands-on approach makes all the difference.",
      avatar: "SC"
    },
    {
      name: "Michael Rodriguez",
      role: "DIY Enthusiast", 
      text: "From zero knowledge to building professional battery packs. The course structure is perfect.",
      avatar: "MR"
    }
  ],
  
  // Course Stats
  stats: [
    { number: "500+", label: "Students Trained" },
    { number: "8", label: "Course Modules" }, 
    { number: "40+", label: "Practical Lessons" },
    { number: "70%", label: "Cost Savings" }
  ],
  
  // Contact Information
  contact: {
    email: "info@qubitcenter.com",
    phone: "+1 (555) 123-4567",
    address: "123 Innovation Drive, Tech City, TC 12345"
  },
  
  // Enrollment Information
  enrollment: {
    price: "$297",
    duration: "6 Weeks",
    format: "Online + Practical Labs",
    certificate: "Professional Certificate",
    support: "24/7 Instructor Support"
  }
};